import { IListUser } from 'src/redux/slices/users';

// Cheques the company writes to pay others (not customer cheques received).
export enum IssuedChequeStatus {
  ISSUED = 'Issued',
  HOLDING = 'Holding',
  REALIZED = 'Realized',
  RETURNED = 'Returned',
  PAYING = 'Paying',
  PAID = 'Paid',
}

export enum IssuedChequeBank {
  BANK_OF_CEYLON = 'Bank of Ceylon',
  PEOPLES_BANK = "People's Bank",
}

export enum IssuedChequeType {
  RAW_MATERIALS = 'Raw Materials',
  OTHER = 'Other',
}

export const ISSUED_CHEQUE_STATUS_OPTIONS = [
  { value: IssuedChequeStatus.ISSUED, label: 'Issued' },
  { value: IssuedChequeStatus.HOLDING, label: 'Holding' },
  { value: IssuedChequeStatus.REALIZED, label: 'Realized' },
  { value: IssuedChequeStatus.RETURNED, label: 'Returned' },
  { value: IssuedChequeStatus.PAYING, label: 'Paying' },
  { value: IssuedChequeStatus.PAID, label: 'Paid' },
];

export const ISSUED_CHEQUE_BANK_OPTIONS = Object.values(IssuedChequeBank);

export const ISSUED_CHEQUE_TYPE_OPTIONS = Object.values(IssuedChequeType);

// Where an Issued cheque can go by hand; Holding/Returned move on through
// payments (Paying, then Paid).
export const ISSUED_CHEQUE_NEXT_STATUSES = [
  IssuedChequeStatus.REALIZED,
  IssuedChequeStatus.RETURNED,
  IssuedChequeStatus.HOLDING,
];

// Statuses in which payments to the payee can be recorded.
export const ISSUED_CHEQUE_PAYABLE_STATUSES = [
  IssuedChequeStatus.HOLDING,
  IssuedChequeStatus.RETURNED,
  IssuedChequeStatus.PAYING,
];

export const getIssuedChequeStatusColor = (status?: string) => {
  switch (status) {
    case IssuedChequeStatus.REALIZED:
    case IssuedChequeStatus.PAID:
      return 'success';
    case IssuedChequeStatus.RETURNED:
      return 'error';
    case IssuedChequeStatus.HOLDING:
    case IssuedChequeStatus.PAYING:
      return 'warning';
    default:
      return 'info';
  }
};

export interface IIssuedChequeListItem {
  _id: string;
  bank: IssuedChequeBank;
  chequeNumber: string;
  chequeDate: string;
  amountInCents: number;
  type: IssuedChequeType;
  payee: string;
  note?: string | null;
  status: IssuedChequeStatus;
  createdAt: string;
  updatedAt: string;
}

export interface IIssuedChequeHistory {
  status: IssuedChequeStatus;
  date: string;
  note?: string | null;
  by: IListUser | null;
  at: string;
}

export interface IIssuedChequeItem extends IIssuedChequeListItem {
  history: IIssuedChequeHistory[];
  paidInCents: number;
  createdBy: IListUser;
  updatedBy: IListUser;
}

export interface IIssuedChequePayment {
  _id: string;
  paymentDate: string;
  amountInCents: number;
  note?: string | null;
  createdBy?: IListUser;
  createdAt: string;
}

export type IIssuedChequeFilters = {
  generalSearch: string;
  type: IssuedChequeType | null;
  bank: IssuedChequeBank | null;
};

export type IIssuedChequeSort = {
  sortBy: string;
  order: 'asc' | 'desc';
};
